module.exports = __webpack_public_path__ + "img/w3_paste_dark.de7e44b3.png";